import { labelFormToQuery as formToQuery } from './labelFormToQuery';
import { labelQueryToForm as queryToForm } from './labelQueryToForm';

export default {formToQuery, queryToForm}